"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _idbReactTranslations = require("@identitybuilding/idb-react-translations");

var _idbReactTranslations2 = _interopRequireDefault(_idbReactTranslations);

var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sidebar = function Sidebar(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      typingTimeout = _useState4[0],
      setTypingTimeout = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      searchValue = _useState6[0],
      setSearchValue = _useState6[1];

  var translate = function translate(e) {
    return (0, _idbReactTranslations2.default)(e, props.lang);
  };

  var CancelToken = _axios2.default.CancelToken;
  var source = CancelToken.source();

  var searchNis = function searchNis(e) {
    if (typingTimeout) clearTimeout(typingTimeout);
    setTimeout((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source.cancel();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    })), 1000);
    var value = "";
    if (e) {
      setSearchValue(e.target.value);
      value = e.target.value;
    }

    setTypingTimeout(setTimeout(function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var as_model, stringFields, numberFields, option, data, _suggestions;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                as_model = require("../models/index.js").default;
                stringFields = ["name_nl", "name_fr", "name_de", "name_en", "submunicipality_set.name_nl", "submunicipality_set.name_fr", "submunicipality_set.name_de", "submunicipality_set.name_en", "nis_code", "nis_code_1970", "nis_code_1977", "submunicipality_set.nis_code_1970", "submunicipality_set.nis_code_1977"];
                numberFields = ["pkancode", "nis_code", "nis_code_1970", "nis_code_1977", "submunicipality_set.pkancode", "submunicipality_set.nis_code_1970", "submunicipality_set.nis_code_1977"];
                option = {};

                if (isNaN(value)) {
                  option = {
                    from: 0,
                    size: 581,
                    query: {
                      query_string: {
                        query: "*" + value + "*",
                        fields: stringFields,
                        tie_breaker: 0.3
                      }
                    },
                    sort: [{
                      pkancode: {
                        order: "asc"
                      }
                    }]
                  };
                } else {
                  option = {
                    size: 581,
                    query: {
                      query_string: {
                        query: "" + value,
                        fields: numberFields,
                        tie_breaker: 0.3
                      }
                    },
                    sort: [{
                      pkancode: {
                        order: "asc"
                      }
                    }]
                  };
                }

                if (!value) {
                  _context2.next = 11;
                  break;
                }

                data = [];
                _context2.next = 9;
                return _axios2.default.get("https://search-osn-management-hkfarflgp5aj2vbhfzvmyycuuy.eu-central-1.es.amazonaws.com/municipalities/_search", {
                  auth: {
                    username: "osn-admin",
                    password: "O15s19n14!"
                  },
                  params: {
                    source_content_type: "application/json",
                    source: (0, _stringify2.default)(option)
                  },
                  cancelToken: source.token
                }).then(function (res) {
                  data = as_model(res.data.hits.hits, props.lang, translate, value);
                  return data;
                }).catch(function (error) {
                  console.log(error);
                });

              case 9:
                _suggestions = _context2.sent;

                if (_suggestions && _suggestions.length > 0) {
                  setSuggestions(_suggestions);
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), 500));
  };

  var openUrl = function openUrl(e, i) {
    var name = e.name;
    // .replace('â', 'a')
    //   .replace(" (stad)", "")
    //   .replace(" (ville)", "")
    //   .replace(" (stadt)", "")
    //   .replace(" city", "")
    //   .replace(/\ /g, "")
    //   .replace("'", "");
    if (name === "sgravenbrakel") {
      name = "s-gravenbrakel";
    }
    if (name === "Mont-de-lEnclus") {
      name = "montdelenclus";
    }
    if (name === "LesBonsVillers") {
      name = "les-bons-villers";
    }

    var parent = e.parent && e.parent.replace(" (stad)", "").replace(" (ville)", "").replace(" (stadt)", "").replace(" city", "").replace(/\ /g, "").replace("'", "");
    if (parent === "sgravenbrakel") {
      parent = "s-gravenbrakel";
    }
    if (parent === "Mont-de-lEnclus") {
      parent = "montdelenclus";
    }
    if (name === "LesBonsVillers") {
      name = "les-bons-villers";
    }

    if (e.parent_slug && e.type === "municipality") {
      parent = e.parent_slug.toLowerCase();
    }
    // else if (e.parent_slug) {
    //     await axios.get(`https://api.ondernemersnetwerk.be/location/nis/by-name/${e.parent_slug}`)
    //         .then((res) => {
    //             let as_model = require(`../models/index.js`).default;
    //             let data = as_model(res.data, props.lang, translate)
    //             parent = data[0].name.toLowerCase()
    //         })
    // }

    // if (e.type === 'submunicipality') { window.open(`https://${parent.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    // else if (e.parent_slug && e.type === 'municipality') { window.open(`https://${parent.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    // else { window.open(`https://${name.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    if (e.postal_code == "9100" || e.postal_code == "9111" || e.postal_code == "9112") {
      return "https://sint-niklaas." + props.baseUrl;
    }
    // all postcodes of the submunicipalities redirects to the municipality site
    return "https://" + e.name + "." + props.baseUrl;
  };

  return _react2.default.createElement(
    "div",
    { className: "mapDrawer " + (props.className ? props.className : "") },
    _react2.default.createElement(
      "div",
      { className: "mapDrawerTop info" },
      _react2.default.createElement("img", {
        id: "procentLogo",
        src: require("../images/" + (props.lang === "nl" ? "logo.png" : "logo_fr.png")),
        alt: "Logo of 100% lokaal"
      }),
      _react2.default.createElement(
        "span",
        null,
        translate("in_colaberation_with")
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "searchbar_wrapper" },
      _react2.default.createElement(
        "div",
        { className: "searchbar" },
        _react2.default.createElement(_idbReactUiElements.OsnInputText, {
          className: "searchMunicipality",
          label: translate("search"),
          icon: "Search",
          placeholder: translate("search"),
          template: 1,
          onKeyDown: function onKeyDown() {
            return setTimeout(function () {
              searchNis();
            }, 500);
          },
          onChange: function onChange(e) {
            return searchNis(e);
          },
          close: true
        }),
        _react2.default.createElement(_idbReactUiElements.OsnSelect, {
          active: window.location.hostname === "www.100procentlokaal.be" ? "NL" : "FR",
          options: [{ id: 1, name: "NL" }, { id: 2, name: "FR" }],
          onChange: function onChange(e) {
            return e.name === "NL" ? window.location.href = "https://www.100procentlokaal.be" : window.location.href = "https://www.100pourcentlocale.be";
          }
        })
      ),
      searchValue && suggestions && suggestions.length > 0 ? _react2.default.createElement(
        "div",
        { className: "auto_suggestion_wrapper" },
        suggestions.map(function (res, index) {
          return (
            // <div className={`auto_suggestion ${res.type}`} onClick={() => { res.type !== 'sub_municipality' && openUrl(res, index) }} key={index}>
            _react2.default.createElement(
              "a",
              {
                key: index,
                className: "auto_suggestion " + res.type,
                href: openUrl(res, index),
                rel: "nofollow noopener noreferrer",
                target: "_blank"
              },
              _react2.default.createElement(
                "span",
                null,
                res.text
              )
            )
            // </div>

          );
        })
      ) : translate("search_municipality")
    ),
    _react2.default.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column" } },
      _react2.default.createElement(
        "video",
        { className: "video", autoPlay: true, controls: true, muted: true },
        _react2.default.createElement("source", {
          src: "https://o-sn.be/seg/www.100procentlokaal.be%20-%20voor-steden-en-gemeenten.mp4",
          type: "video/mp4"
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "mapOptions" },
        _react2.default.createElement(
          "h2",
          null,
          translate("borders")
        ),
        props.borders.map(function (border, index) {
          return _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
            key: index,
            checked: border.active,
            name: translate(border.name),
            onChange: function onChange() {
              return props.checkboxHandler(border, index);
            },
            value: translate(border.name),
            className: border.name
          });
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "mapOptions" },
        _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
          checked: props.baseLayer,
          name: translate("map"),
          onChange: function onChange() {
            return props.setBaseLayer(!props.baseLayer);
          },
          value: translate("map")
        }),
        _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
          checked: props.baseNames,
          name: translate("municipality_names"),
          onChange: function onChange() {
            return props.setBaseNames(!props.baseNames);
          },
          value: translate("municipality_names")
        })
      ),
      _react2.default.createElement("div", { id: "custom-map-controls" })
    )
  );
};

exports.default = Sidebar;